import http from 'plugins/axios';

export default {
  getCurrencyList() {
    return http.post({
      url: '/la/admin/mytoken/search'
    });
  },
  getCurrencyDetail(id) {
    return http.get({
      url: `/la/admin/mytoken/detail/${id}`
    });
  },
  addCurrency(data) {
    //symbol货币名称，name货币全称
    return http.post({
      url: '/la/admin/mytoken/addToken',
      data,
      dataType: 'form'
    });
  },
  bindThirdPart(id) {
    return http.get({
      url: `/la/admin/mytoken/createTokenToMytoken/${id}`
    });
  },
  getCoinList() {
    return http.get({
      url: '/la/admin/mytoken/coinList'
    });
  }
};
